import faqCategory from "./faq-category";
import faqQuestion from "./faq-question";
import accordionContent from "shared/modules/accordion/accordion";

/**
 * FAQ Result
 * this module handles the result of the category.
 */
function faqResult(el, faq, app) {
  const $el = $(el);
  const $ldjsonContainer = $el.siblings("[data-js-faq-ldjson-container]");
  const $categories = $el.find("[data-js-faq-categories]");

  const $showMore = $el.find("[data-js-faq-show-more]");
  const $single = $el.find("[data-js-faq-single]");
  let collection = [];
  let single = false;
  let visible = 0;

  const hasNonEmptyText = (block) => {
    if (!block || !block.texts) return false;
    const lines = Array.isArray(block.texts) ? block.texts : [block.texts];
    return lines.some((line) => line != null && String(line).trim().length > 0);
  };

  const getAnswerBlock = (q) => {
    if (hasNonEmptyText(q.private)) return q.private;
    if (hasNonEmptyText(q.company)) return q.company;
    return q.private || q.company || null;
  };

  const origin =
    typeof window !== "undefined" && window.location
      ? window.location.origin
      : "";
  const toAbsoluteUrl = (url) => {
    if (!url || typeof url !== "string") return url;
    const u = url.trim();
    if (/^https?:\/\//i.test(u)) return u;
    return u.startsWith("/") ? origin + u : u;
  };

  const toImageObject = (item) => {
    if (item == null) return null;
    if (typeof item === "string") {
      const url = toAbsoluteUrl(item.trim());
      return url ? { "@type": "ImageObject", contentUrl: url } : null;
    }
    const rawUrl =
      item.contentUrl || item.url || (typeof item.src === "string" ? item.src : null);
    if (!rawUrl) return null;
    const url = toAbsoluteUrl(rawUrl);
    const obj = { "@type": "ImageObject", contentUrl: url };
    const caption = item.name || item.alt || item.caption || item.text;
    if (caption != null && String(caption).trim()) {
      obj.name = String(caption).trim();
    }
    return obj;
  };

  const toCitation = (item) => {
    if (item == null) return null;
    const rawUrl =
      typeof item === "string" ? item.trim() : (item.url || item.href || "").trim();
    if (!rawUrl) return null;
    const url = toAbsoluteUrl(rawUrl);
    const name = item.name || item.title || item.text;
    return name != null && String(name).trim()
      ? { "@type": "WebPage", url, name: String(name).trim() }
      : { "@type": "WebPage", url };
  };

  const buildFaqItemFromQuestion = (q) => {
    const block = getAnswerBlock(q);
    const title = q.headline != null ? String(q.headline).trim() : "";
    let text = "";
    let images = [];
    let links = [];

    if (block) {
      if (block.texts) {
        const lines = Array.isArray(block.texts) ? block.texts : [block.texts];
        text = lines
          .map((line) => (line != null ? String(line).trim() : ""))
          .filter(Boolean)
          .join("\n");
      }
      const rawImage = block.image ?? q.image;
      images =
        rawImage != null ? [rawImage].map(toImageObject).filter(Boolean) : [];
      const rawLinks = block.links ?? q.links ?? [];
      links = (Array.isArray(rawLinks) ? rawLinks : [rawLinks])
        .map(toCitation)
        .filter(Boolean);
    }

    return { title, text, images, links };
  };

  const injectFaqSchema = (faqItems) => {
    if (!$ldjsonContainer.length || !faqItems.length) return;
    const schema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqItems.map((item) => {
        const acceptedAnswer = {
          "@type": "Answer",
          text: item.text || "",
        };
        if (item.images.length) {
          acceptedAnswer.image =
            item.images.length === 1 ? item.images[0] : item.images;
        }
        if (item.links.length) {
          acceptedAnswer.citation =
            item.links.length === 1 ? item.links[0] : item.links;
        }
        return {
          "@type": "Question",
          name: item.title,
          acceptedAnswer,
        };
      }),
    };
    let jsonString = JSON.stringify(schema, null, 2);
    jsonString = jsonString.replace(
      /<\s*\/\s*script\s*>/gi,
      "\\u003c/script\\u003e",
    );
    $ldjsonContainer[0].innerHTML =
      '<script type="application/ld+json">' + jsonString + "</scr" + "ipt>";
  };

  const addVisible = function () {
    const $items = $categories.find("[data-js-faq-question]");
    $items.slice(visible, visible + 10).removeClass("Ge-Hidden");
    visible += 10;

    if (visible < $items.length) {
      $showMore.removeClass("Ge-Hidden");
    } else {
      $showMore.addClass("Ge-Hidden");
    }
  };

  $showMore.click((evt) => {
    evt.preventDefault();
    addVisible();
  });

  const searchingStarted = function () {
    $categories.addClass("Ge-FaqResult-Categories--Searching");
  };

  const clearResults = function () {
    $showMore.addClass("Ge-Hidden");
    $single.empty();
    $ldjsonContainer.empty();
    collection.forEach((item) => item.remove());
    collection = [];
  };

  /**
   *
   */
  const renderResult = function (result) {
    if (single) {
      $single.empty();
      single = false;
    }

    // ... remove existing result.
    collection.forEach((item) => item.remove());
    collection = [];

    // makes sure that we have
    let noHits =
      !result.categories.length ||
      !result.categories[0].questions ||
      !result.categories[0].questions.length;

    if (noHits) {
      const errorMsg =
        typeof dictionaryFaqResults !== "undefined"
          ? dictionaryFaqResults.noHitsMessage
          : "";
      app.trigger("msgGlobal", [errorMsg, "faqError", "warning", true, false]);
    }

    $categories.addClass("Ge-Hidden");

    const faqItems = result.categories.flatMap((cat) =>
      (cat.questions || []).map(buildFaqItemFromQuestion),
    );
    injectFaqSchema(faqItems);

    // render all the items...
    result.categories.forEach((model) => {
      let view = faqCategory(null, faq, model, app);
      const $categoryEl = view.render().$el;
      $categories.append($categoryEl);
      collection.push(view);
    });

    const $items = $categories.find("[data-js-faq-question]");
    if (result.categories.length === 1) {
      $items.addClass("Ge-Hidden");
      visible = 0;
      addVisible();
    } else {
      $items.removeClass("Ge-Hidden");
    }
    $categories.removeClass("Ge-Hidden");

    // initialise each accordion group
    const $inPageAccordions = $categories.find("[data-js-accordion]");
    $.each($inPageAccordions, function (index, el) {
      accordionContent(el, app);
    });

    $categories.removeClass("Ge-FaqResult-Categories--Searching");
  };

  /**
   * Renders a single question (e.g. direct link ?question=id).
   * Injects FAQ schema with only this question into the LD+JSON container.
   */
  const renderSingle = function (data) {
    single = true;
    let headline = $("<h1>", { class: "Ge-Typo--lg" }).text(data.headline);

    $single.empty().append(headline);

    const singleFaqItem = buildFaqItemFromQuestion(data);
    injectFaqSchema([singleFaqItem]);

    let question = faqQuestion($single, faq, data, app, true);
    question.render();
    question.logView();
  };

  // when we've gotten a new result,
  // render it.
  faq.on("result", renderResult);
  faq.on("clearResults", clearResults);
  faq.on("searching", searchingStarted);
  faq.on("single", renderSingle);

  return { el, $el };
}

export default faqResult;
